import { useSelector } from 'react-redux';
import { AssignConnectionModal, Modal } from 'components-antd';
import { useDispatch } from 'react-redux';
import { appSetShowInviteTeamMemberAction } from 'store/actions/app';
import { getInvitedTeamMemberValues, isInviteTeamMemberModalOpened } from 'store/selectors/app';
import styles from './styles.module.scss';
import Details from './Details';
import { useState } from 'react';
import classNames from 'classnames';
import { handleSendTeamMemberInviteForm } from 'store/effects';
import { TEAM_OWNER } from 'settings/constants/roles';
import activeSubscriptionTeamData from 'store/reducers/subscription/activeSubscriptionTeamData';
import { optimisticActiveSubscriptionTeamDataAction } from 'store/actions/subscription';
import { usePollInvoiceData } from 'pages/Settings/Subscription/usePollInvoiceData';
import { getAgentTeamRoleSelector } from 'store/selectors/agentTeamDetail';
import SendInvite from '../SendInvite';
import { postReinviteTeamMember } from 'api/teamList';

const InviteTeamMember = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [skipped, setSkipped] = useState(false);
  const [inviteLink, setInviteLink] = useState(false);
  const [userId, setUserId] = useState();
  const isInviteOpened = useSelector(isInviteTeamMemberModalOpened);
  const agentRole = useSelector(getAgentTeamRoleSelector);
  const invitedTeamMemberValues = useSelector(getInvitedTeamMemberValues);

  const { pollInvoiceData } = usePollInvoiceData();

  const handleNext = () => {
    setStep((prev) => prev + 1);
  };

  const onSubmit = ({ connections }) => {
    setIsLoading(true);
    const body = {
      firstName: invitedTeamMemberValues?.firstName,
      lastName: invitedTeamMemberValues?.lastName,
      email: invitedTeamMemberValues?.email,
      role: invitedTeamMemberValues?.role,
      titleId: invitedTeamMemberValues?.title?.titleId || undefined,
      assignedToAdmins: connections,
      canCreateTransaction: invitedTeamMemberValues?.canCreateTransaction,
    };
    dispatch(
      handleSendTeamMemberInviteForm(body, (err, res) => {
        if (!err) {
          setUserId(res?.data?.Id);
          setInviteLink(res?.data?.InviteLink);
          if (agentRole === TEAM_OWNER && activeSubscriptionTeamData?.isSubscriptionActive) {
            //Refresh billing screen data
            dispatch(optimisticActiveSubscriptionTeamDataAction());
            pollInvoiceData();
          }
        } else {
          setStep(0);
        }
        setIsLoading(false);
      }),
    );
  };

  const sendEmail = async () => {
    setIsLoading(true);
    await postReinviteTeamMember({ id: userId, useExistingToken: true });
    setIsLoading(false);
    handleNext();
  };

  const renderStep = () => {
    switch (step) {
      case 0:
        return <Details handleNext={handleNext} />;
      case 1:
        return (
          <AssignConnectionModal
            disableOnEmpty={false}
            closeOnClientEmpty
            noModal
            onNext={handleNext}
            onInvite={onSubmit}
            mode="AgentInvite"
          />
        );
      default:
        return (
          <SendInvite
            isLoading={isLoading}
            stepOne={
              <p>
                {`All set! Are you ready to send an email invitation to ${invitedTeamMemberValues?.firstName}? 🚀`}
              </p>
            }
            stepTwo={
              skipped ? (
                <p style={{ marginBottom: 0 }}>
                  <span>
                    An <b>email invitation</b> was not sent to{' '}
                    <b>{`${invitedTeamMemberValues?.firstName} ${invitedTeamMemberValues?.lastName}`}</b>
                    . You can send one from their profile or you can invite them through the link
                    below.
                  </span>
                </p>
              ) : (
                <p>
                  🎉
                  <br /> An email invitation was sent to{' '}
                  {`${invitedTeamMemberValues?.firstName} ${invitedTeamMemberValues?.lastName}`}.
                </p>
              )
            }
            onSubmit={sendEmail}
            onSkip={() => {
              setSkipped(true);
              handleNext();
            }}
            inviteLink={inviteLink}
            step={step > 2 ? 2 : 1}
          />
        );
    }
  };

  return (
    <Modal
      open={isInviteOpened}
      width={step > 1 ? 475 : 675}
      footer={null}
      onCancel={() => {
        dispatch(appSetShowInviteTeamMemberAction(false));
      }}
      className={classNames(styles.inviteTeamMemberModal, { [styles.white]: step > 1 })}
      maskClosable={step === 3}
      destroyOnClose={true}
    >
      {renderStep()}
    </Modal>
  );
};

export default InviteTeamMember;
